<template>
    <div>
        <table style="width: 90%; margin: 0 5%; margin-top: 20px;">
            <tr>
                <td style="height: 30px; width: 25%;">
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">姓名：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.staff_name}}</el-col>
                    </el-row>
                </td>
                <td style="width: 25%;">
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">性别：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.staff_gender_title}}</el-col>
                    </el-row>
                </td>
                <td style="width: 25%;">
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">身份证号：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.staff_card}}</el-col>
                    </el-row>
                </td>
                <td style="width: 25%;">
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">出生日期：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.birth_date}}</el-col>
                    </el-row>
                </td>
            </tr>
            
            <tr>
                <td style="height: 30px;">
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">年龄：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.age}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">手机号：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.staff_telephone}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">民族：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.nation}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">籍贯：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.native_place}}</el-col>
                    </el-row>
                </td>
            </tr>
            
            <tr>
                <td style="height: 30px;">
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">身份证地址：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.card_address}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">现居住地地址：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.residence}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">户口所在地：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.domicile_place}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">户籍性质：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.household_register}}</el-col>
                    </el-row>
                </td>
            </tr>
            
            <tr>
                <td style="height: 30px;">
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">银行卡号：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.bank_no}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">开户行：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.bankName}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">第一学历：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.first_degree}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">最高学历：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.second_degree}}</el-col>
                    </el-row>
                </td>
                
            </tr>
            
            <tr>
                <td style="height: 30px;">
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">邮箱：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.mailbox}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">微信：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.we_chat}}</el-col>
                    </el-row>
                </td>
                <td>
                    <el-row>
                        <el-col :span="10" style="text-align: right; color: #a1a1a1; line-height: 30px;">健康状况：</el-col>
                        <el-col :span="14" style="line-height: 30px;">{{from.health}}</el-col>
                    </el-row>
                </td>
                <td></td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        props: ["from"],
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// basic.vue?4e808b39